<template>
  <div ref="refCartMobile">
    <!--    <transition name="fade">-->
    <div class="menu-bordered" v-if="getGameConsole === 'default'">
      <v-slide-group>
        <v-slide-item
          v-for="(menu, idx) in menu_items"
          :key="$uuid.v1()"
          v-slot="{ active, toggle }"
          v-if="
            menu.action != 'live' ||
            (menu.action == 'live' && getSettings.enableLive)
          "
        >
          <div class="menu-box" @click="actionDispatcher(menu.action)">
            <div class="icon">
              <template v-if="menu.action == 'live'">
                <!--                  <v-badge :content="getTotalCountLive()" :value="getTotalCountLive()" color="#ff0000" overlap>-->
                <!--                    <v-icon dense>-->
                <!--                      {{ menu.icon }}-->
                <!--                    </v-icon>-->
                <!--                  </v-badge>-->
                <v-icon dense>
                  {{ menu.icon }}
                </v-icon>
              </template>
              <template v-else-if="menu.action == 'cart'">
                <v-badge
                  :content="getBet.odds.length"
                  :value="getBet.odds.length"
                  color="#fed430"
                  overlap
                  class="text-black"
                >
                  <v-icon dense>
                    {{ menu.icon }}
                  </v-icon>
                </v-badge>
              </template>
              <template v-else>
                <v-icon dense>
                  {{ menu.icon }}
                </v-icon>
              </template>
              <div
                class="text"
                :class="isSelected(menu.action) ? 'selected' : ''"
              >
                {{ $t(menu.text) }}
              </div>
            </div>
          </div>
        </v-slide-item>
      </v-slide-group>
    </div>
    <div v-else-if="getGameConsole === 'marketview'">
      <v-row>
        <v-col cols="12">
          <search></search>
        </v-col>
      </v-row>
    </div>

    <!--    </transition>-->

    <!--    <v-navigation-drawer v-model="drawer" fixed left temporary width="100%" class="nav-mobile revengeBetConsole">-->
    <!--      <v-row class="no-margin">-->
    <!--        <v-col cols="12" class="header-nav-mobile">-->
    <!--          <span class="title-box text-uppercase pl-2">{{ $t('menu') }}</span>-->
    <!--          <v-spacer></v-spacer>-->
    <!--          <v-icon @click.stop="drawer = !drawer;selected = ''" large class="pr-4">mdi-close</v-icon>-->
    <!--        </v-col>-->
    <!--        <v-divider></v-divider>-->
    <!--        <v-col cols="12" class="bordered-element left-module-mobile">-->
    <!--          <LeftModule></LeftModule>-->
    <!--        </v-col>-->
    <!--      </v-row>-->

    <!--    </v-navigation-drawer>-->

    <!-- tree -->
    <v-dialog
      v-model="drawer"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      class="revengeBetConsole"
    >
      <v-row class="no-margin cart-mobile">
        <!--        <v-col cols="12" class="header-nav-mobile">-->
        <!--          <span class="title-box text-uppercase pl-2">{{ $t('menu') }}</span>-->
        <!--          <v-spacer></v-spacer>-->
        <!--          <v-icon @click.stop="drawer = !drawer; selected = ''">mdi-close</v-icon>-->
        <!--        </v-col>-->
        <v-col cols="12" class="text-right pt-2 pb-2 d-flex-center-all">
          <span class="title-box text-uppercase pl-2">{{ $t('menu') }}</span>
          <v-spacer></v-spacer>
          <v-icon
            @click.stop="
              menuHandler()
              selected = ''
            "
            >mdi-close</v-icon
          >
        </v-col>
        <v-divider></v-divider>
        <v-col cols="12" class="left-module-mobile">
          <LeftModule></LeftModule>
        </v-col>
      </v-row>
    </v-dialog>
    <!-- /cart -->

    <!-- cart -->
    <v-dialog
      v-model="drawer_cart"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      class="revengeBetConsole"
    >
      <v-row class="no-margin cart-mobile">
        <v-col cols="12" class="text-right pt-2 pb-2 align-center">
          <v-spacer></v-spacer>
          <svg
            @click.stop="
              cartHandler()
              selected = ''
            "
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.7699 1.33324L6.99991 5.11324L3.22991 1.33324C2.9784 1.08173 2.63727 0.94043 2.28158 0.94043C1.92588 0.94043 1.58476 1.08173 1.33324 1.33324C1.08173 1.58476 0.94043 1.92588 0.94043 2.28158C0.94043 2.63727 1.08173 2.9784 1.33324 3.22991L5.11324 6.99991L1.33324 10.7699C1.08173 11.0214 0.94043 11.3625 0.94043 11.7182C0.94043 12.0739 1.08173 12.4151 1.33324 12.6666C1.58476 12.9181 1.92588 13.0594 2.28158 13.0594C2.63727 13.0594 2.9784 12.9181 3.22991 12.6666L6.99991 8.88658L10.7699 12.6666C11.0214 12.9181 11.3625 13.0594 11.7182 13.0594C12.0739 13.0594 12.4151 12.9181 12.6666 12.6666C12.9181 12.4151 13.0594 12.0739 13.0594 11.7182C13.0594 11.3625 12.9181 11.0214 12.6666 10.7699L8.88658 6.99991L12.6666 3.22991C12.7911 3.10537 12.8899 2.95753 12.9573 2.79481C13.0247 2.63209 13.0594 2.4577 13.0594 2.28158C13.0594 2.10545 13.0247 1.93106 12.9573 1.76834C12.8899 1.60563 12.7911 1.45778 12.6666 1.33324C12.542 1.20871 12.3942 1.10992 12.2315 1.04252C12.0688 0.97512 11.8944 0.94043 11.7182 0.94043C11.3625 0.94043 11.0214 1.08173 10.7699 1.33324Z"
            />
          </svg>
          <!--                    <v-icon @click.stop="cartHandler(); selected = ''">mdi-close</v-icon>-->
        </v-col>
        <v-col cols="12" sm="12" md="12" class="bordered-element">
          <RightModule></RightModule>
        </v-col>
      </v-row>
    </v-dialog>
    <!-- /cart -->

    <template v-if="getGameConsole === 'default'">
      <v-dialog
        ref="Dialog7"
        v-model="dialogSearch"
        max-width="290"
        origin="top center"
        content-class="modal-on-top"
      >
        <v-card class="pa-2">
          <Search></Search>
          <v-card-text class="pa-2">
            {{ $t('searchHelp') }}
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LeftModule from '@/components/Left.vue'
import Search from '@/components/generic/Search'
import CenterModule from '@/components/Center'
import RightModule from '@/components/Right'

export default {
  name: 'TopNavigationMobile',
  data() {
    return {
      selected: 'home',
      drawer: false,
      drawer_cart: false,
      count_live_total: '',
      dialogSearch: false,
      menu_items: [
        { text: this.$t('generic.sport'), icon: 'mdi-menu', action: 'menu' },
        { text: this.$t('home'), icon: 'mdi-home', action: 'home' },
        { text: this.$t('live'), icon: 'mdi-alarm-plus', action: 'live' },
        { text: this.$t('search'), icon: 'mdi-magnify', action: 'search' },
        { text: this.$t('betSlip'), icon: 'mdi-file-document', action: 'cart' },
      ],
      lastScroll: 0,
      viewHeader: true,
      icarus: window.icarus,
      openlivesection:
        window.openlivesection != null
          ? window.openlivesection === 'true' || window.openlivesection === true
            ? true
            : false
          : false,
      openTree:
        window.openTree != null
          ? window.openTree === 'true' || window.openTree === true
            ? true
            : false
          : false,
    }
  },
  components: {
    Search,
    LeftModule,
    CenterModule,
    RightModule,
  },
  computed: {
    ...mapGetters({
      getAuthenticated: 'user/getAuthenticated',
      getId: 'user/getId',
      getLogin: 'user/getLogin',
      getBet: 'cart/getBet',
      getCountLive: 'odds/getCountLive',
      getLiveMode: 'odds/getLiveMode',
      getSettings: 'cart/getSettings',
      getGameConsole: 'settings/getGameConsole',
      getMobileCartOpen: 'cart/getMobileCartOpen',
      getProgramOpen: 'settings/getProgramOpen',
    }),
  },
  methods: {
    ...mapActions({
      setLiveMode: 'odds/setLiveMode',
      setMobileCartOpen: 'cart/setMobileCartOpen',
      setProgramOpen: 'settings/setProgramOpen',
      closePrematchEventsCards: 'odds/closePrematchEventsCards',
    }),

    async scrollToTop() {
      try {
        const iframe = window.frameElement
        const originalHeight = iframe ? iframe.style.height : null

        if (iframe) {
          iframe.style.height = '100vh'
        }

        function safeScroll(el) {
          return new Promise(resolve => {
            if (!el) return resolve()

            //console.log(`🔵 Scroll start: Element ${el.tagName || 'WINDOW'} at position ${el.scrollTop}`);

            el.scrollTo({ top: 1, behavior: 'instant' })

            requestAnimationFrame(() => {
              el.scrollTo({ top: 0, behavior: 'smooth' })

              setTimeout(() => {
                //console.log(`🟢 Scroll end: Element ${el.tagName || 'WINDOW'} at position ${el.scrollTop}`);

                // if (el.scrollTop > 0) {
                //     console.warn(`⚠️ ATTENZIONE: ${el.tagName || 'WINDOW'} NON è tornato a 0!`);
                // }

                resolve()
              }, 50)
            })
          })
        }

        // 1️⃣ scroll the iframe
        await safeScroll(window)

        // 2️⃣ Scroll the parent if we are into the iframe
        if (window.parent !== window) {
          try {
            await safeScroll(window.parent)
          } catch (error) {
            console.warn('❌ Parent scroll failed:', error)
          }
        }

        // 3️⃣ Scrolla la modale dentro l'iframe
        const modal = document.querySelector('.modal, .scrollable')
        if (modal) {
          await safeScroll(modal)
        }

        // 4️⃣ Set  iframe height to initial value
        if (iframe && originalHeight) {
          setTimeout(() => {
            iframe.style.height = originalHeight
          }, 1000)
        }

        // 5️⃣ Scroll all these elements
        const carts = document.querySelectorAll(
          '.cart, .cart-container, .cart-mobile, .cart-content, .bet-odds-summary, .bet-console-prefix'
        )
        for (const cart of carts) {
          await safeScroll(cart)
        }

        // this.findScrollableElements();

        //console.log("✅ Scroll completed");
      } catch (error) {
        console.warn('❌ Generic error while scrolling:', error)
      }
    },

    resetCartScroll() {
      const carts = document.querySelectorAll(
        '.cart, .cart-container, .cart-mobile, .cart-content, .bet-odds-summary, .revengeBetConsole, .bet-console-prefix'
      )
      carts.forEach(cart => cart.scrollTo({ top: 0, behavior: 'instant' }))

      document.querySelectorAll('*').forEach((el, index) => {
        if (el.scrollHeight > el.clientHeight) {
          // if is scrollable
          el.scrollTo({ top: 0, behavior: 'instant' })
        }
      })
    },
    resetScroll() {
      const scrollableElements = document.querySelectorAll(
        '.v-dialog__content, .cart-content, .v-dialog--fullscreen, .revengeBetConsole, .bet-console-prefix'
      )

      scrollableElements.forEach(element => {
        element.scrollTop = 0
      })

      document.querySelectorAll('*').forEach((el, index) => {
        if (el.scrollHeight > el.clientHeight) {
          el.scrollTo({ top: 0, behavior: 'instant' })
        }
      })
    },

    findScrollableElements() {
      const allElements = document.querySelectorAll('*')
      const scrollableElements = []

      allElements.forEach(el => {
        if (
          el.scrollHeight > el.clientHeight ||
          el.scrollWidth > el.clientWidth
        ) {
          scrollableElements.push(el)
        }
      })

      console.log(
        `🔍 Trovati ${scrollableElements.length} elementi scrollabili:`
      )

      scrollableElements.forEach((el, index) => {
        console.log(`🆔 Elemento ${index + 1}:`, el)
        console.log(`   📏 Altezza: ${el.clientHeight}px`)
        console.log(`   📜 Altezza totale scroll: ${el.scrollHeight}px`)
        console.log(`   📍 ScrollTop attuale: ${el.scrollTop}px`)
        console.log(`   📜 Larghezza totale scroll: ${el.scrollWidth}px`)
        console.log(`   📍 ScrollLeft attuale: ${el.scrollLeft}px`)
        console.log('--------------------------------------------------')
      })

      return scrollableElements
    },

    actionDispatcher(action) {
      this.selected = action
      switch (action) {
        case 'menu':
          this.menuHandler()
          break
        case 'live':
          this.liveHandler()
          break
        case 'search':
          this.searchHandler()
          break
        case 'cart':
          this.cartHandler()
          break
        case 'home':
          this.homeHandler()
          break
      }
    },

    menuHandler() {
      if (!this.drawer) {
        this.scrollToTop() // Call the scroll if we are opening
      } else {
        this.resetCartScroll()
        this.resetScroll()
      }
      this.drawer = !this.drawer
      this.setProgramOpen(this.drawer)
      this.sendStatusTreeToSkin()
    },

    liveHandler() {
      this.setLiveMode({ mode: 'detail' })
      this.selected = 'live'
      this.setMenu(false)
      //console.log('liveHandler');
    },

    searchHandler() {
      this.dialogSearch = true
    },

    cartHandler() {
      this.scrollToTop()

      // 4️⃣ Open cart
      this.drawer_cart = !this.drawer_cart

      if (this.drawer_cart == false) {
        this.resetCartScroll()
        this.resetScroll()
      }
      this.setMobileCartOpen(this.drawer_cart)
      this.sendStatusCartToSkin()
    },

    homeHandler() {
      this.setLiveMode({ mode: 'preview' })
      this.selected = 'home'
    },

    homeHandlerAndResetState() {
      if (localStorage.getItem('event-detail')) {
        localStorage.removeItem('event-detail')
      }
      if (localStorage.getItem('preview-tournament-visited')) {
        localStorage.removeItem('preview-tournament-visited')
      }

      this.homeHandler()
      this.closePrematchEventsCards()
      this.setMenu(false)
    },

    getTotalCountLive() {
      let total = 0
      _.forEach(this.getCountLive, count => {
        total += count.count
      })
      return total
    },

    check(event) {
      // TODO NOTE is still used this thing ? now i remove it temporary
      const currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0 && this.lastScroll <= currentScroll) {
        this.lastScroll = currentScroll
        this.viewHeader = false
      } else {
        this.lastScroll = currentScroll
        this.viewHeader = true
      }
    },

    isSelected(action) {
      if (this.selected == 'action') {
        return true
      } else if (action == 'home' && this.getLiveMode == 'preview') {
        return true
      } else if (action == 'live' && this.getLiveMode == 'detail') {
        return true
      } else {
        return false
      }
    },
    setMenu(status) {
      this.drawer = status
      this.setProgramOpen(this.drawer)
    },
    // sendModeMessageToSkin(){ // todo fix me
    //     const vm = this;
    //
    //     if(this.getGameConsole === 'marketview'){
    //         window.parent.postMessage({
    //             'type': 'sportMode',
    //             'mode': vm.getLiveMode,
    //         }, "*");
    //     }
    // },
    sendStatusCartToSkin() {
      // todo fix me
      const vm = this

      if (this.getGameConsole === 'marketview') {
        window.parent.postMessage(
          {
            type: 'statusCart',
            status: vm.getMobileCartOpen,
          },
          '*'
        )
      }
    },
    sendStatusTreeToSkin() {
      const vm = this

      if (this.getGameConsole === 'marketview') {
        window.parent.postMessage(
          {
            type: 'statusTreeMenu',
            status: vm.getProgramOpen,
          },
          '*'
        )
      }
    },
  },

  mounted() {
    const vm = this
    this.$root.$on('close_sidebar_left', function (value) {
      if (value) {
        vm.menuHandler()
        vm.selected = ''
      }
    })

    this.$root.$on('close_search', function (value) {
      if (value) {
        vm.dialogSearch = !vm.dialogSearch
        vm.selected = ''
      }
    })

    this.$root.$on('cart_handling', function () {
      vm.cartHandler()
    })

    this.$root.$on('open_sidebar_left', function () {
      // console.log('recevied open_sidebar_left event')
      if (vm.getLiveMode == 'detail') {
        vm.homeHandler()
      }

      vm.menuHandler()
    })

    this.$root.$on('set_live_mode_detail', function () {
      //console.log('setting in live mode');
      vm.liveHandler()
    })

    this.$root.$on('set_live_mode_preview', function () {
      //console.log('setting in live mode preview');
      vm.homeHandler()
    })

    this.$root.$on('set_live_mode_preview_and_reset_state', function () {
      //console.log('setting in live mode preview and reset state');
      vm.homeHandlerAndResetState()
    })

    if (this.openlivesection === true) {
      this.liveHandler()
    }

    if (this.openTree === true) {
      this.menuHandler()
    }
  },

  created() {
    //window.addEventListener('scroll', this.check);
  },
  beforeDestroy() {
    this.$root.$off('open_sidebar_left', () => {
      // console.log('destroyed')
    })

    this.$root.$off('set_live_mode_detail', () => {
      //console.log('setting in live mode listener disabled');
    })

    this.$root.$off('set_live_mode_preview', () => {
      //console.log('setting set_live_mode_preview listener disabled');
    })

    this.$root.$off('set_live_mode_preview_and_reset_state', () => {
      //console.log('setting set_live_mode_preview_and_reset_state listener disabled');
    })
  },

  destroyed() {
    //window.removeEventListener('scroll', this.check);
  },
}
</script>

<style type="text/css">
.bet-console-prefix .menu-bordered .menu-box .text.selected {
  color: var(--active-color);
}
</style>
